import { ArticleComponent, ArticleBase } from './article/article.component';
import { HeaderComponent } from './header/header.component';
import { HeaderDetails } from './header/header.component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  headerDetails: HeaderDetails;

  constructor() {

  }

  ngOnInit() {

    this.headerDetails = { 'title' : 'Hello world .. Welcome to my tech log..',
    'description' : 'I am a passionate software engineer driven by a love for solving complex problems through elegant code',
    'img' : '' };
  }

}
